export default "# Projektversionen\n\nHier können Sie die Versionen des Projekts für SBOM Lieferungen verwalten.\n"